const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const calculateOrderProfitApi = async (orderData) => {
  const token = localStorage.getItem('token');
  console.log(orderData)

  if (!token) {
    console.error('[calculateOrderProfitApi] Ошибка: Токен авторизации не найден.');
    // throw new Error('Токен авторизации не найден.');
  }

  try {
    const queryParams = new URLSearchParams(orderData).toString();
    const response = await fetch(`${API_BASE_URL}/admin/lead/leads/orders/calculate-profit?${queryParams}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[calculateOrderProfitApi] Ошибка при расчете прибыли заказа:', errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error('[calculateOrderProfitApi] Ошибка сети или другая ошибка при расчете прибыли заказа:', error);
    throw error;
  }
};